import { useQuery } from '@tanstack/react-query';

import { getAdGroupBidHistory } from '~/services/PublicOfferFeedService';

export const adGroupBidHistoryQueryKeys = {
  all: ['googleAds', 'bidModificationHistory'] as const,
  lists: () => [...adGroupBidHistoryQueryKeys.all, 'list'] as const,
  list: (filters: { customerId: string; campaignId: string; adGroupId: string; page: number; limit: number }) =>
    [...adGroupBidHistoryQueryKeys.lists(), filters] as const,
};

export function useGetAdGroupBidHistory({
  customerId,
  campaignId,
  adGroupId,
  page,
  limit,
  enabled = true,
}: {
  customerId: string;
  campaignId: string;
  adGroupId: string;
  page: number;
  limit: number;
  enabled?: boolean;
}) {
  return useQuery({
    queryKey: adGroupBidHistoryQueryKeys.list({ customerId, campaignId, adGroupId, page, limit }),
    queryFn: async () => {
      return await getAdGroupBidHistory({
        customerId,
        campaignId,
        adGroupId,
        page,
        limit,
      });
    },
    enabled: enabled && Boolean(customerId && campaignId && adGroupId),
  });
}
